import React from 'react';
import MetricsCard from '@/components/parts/MetricsCard';
import { DayMap } from '@/types';
import { useHooks } from '@/components/templates/MetricsBar/hooks';

export interface MetricsBarProps {
  dayMap: DayMap;
}

const MetricsBar: React.FC<MetricsBarProps> = (props) => {
  const {
    todayVal,
    todaySub,
    todayHours,
    weekVal,
    weekSub,
    monthVal,
    monthSub,
    totalVal,
    totalSub
  } = useHooks(props);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 animate-fade-in delay-75">
      <MetricsCard
        title="Today"
        value={todayVal}
        subLabel={todaySub}
        accent={todayHours > 0}
      />
      <MetricsCard
        title="This Week"
        value={weekVal}
        subLabel={weekSub}
      />
      <MetricsCard
        title="This Month"
        value={monthVal}
        subLabel={monthSub}
      />
      <MetricsCard
        title="Total"
        value={totalVal}
        subLabel={totalSub}
      />
    </div>
  );
};

export default MetricsBar;
